import ComponentWithSocket from '../../../lib/component';
import CKEditor from 'ckeditor4-vue';
import { Component } from 'vue-property-decorator';

import moment from 'moment';

@Component({
    components: { ckeditor: CKEditor.component },
})
export default class AuctionsAdd extends ComponentWithSocket {
    public name: string = '';
    public description: string = '';
    public startDate: string = '';
    public startTime: string = '';
    public location: string = '';
    public featuredImage: any = undefined;
    public coverImage: any = undefined;

    public ckeditorConfig: any = {
        entities_latin: false,
        basicEntities: false,
        language: 'en',
    };

    constructor() {
        super();
    }

    beforeRouteLeave(to: any, from: any, next: any) {
        this._beforeLeave(to, from);
        next();
    }

    mounted() {
        // Assign session values to store for global dispatch
        this.wsListener.onPost(
            'admin.auctions',
            (success: boolean, data: any) => {
                if (success) {
                    this.$router.push('/auctions');
                } else {
                    alert(data);
                }
            },
        );
    }

    async addAuction() {
        let startDate;
        let featuredImage: any = '';
        let coverImage: any = '';

        if (this.startDate && this.startTime) {
            startDate = moment(
                this.startDate + ' ' + this.startTime,
                'DD-MM-YYYY HH:mm',
            );
        }

        try {
            if (this.featuredImage) featuredImage = await this.convertToBase64(this.featuredImage);
            if (this.coverImage) coverImage = await this.convertToBase64(this.coverImage);
        } catch (error) {
            console.error('Image upload err:', error);
        }

        let auctionData = {
            name: this.name,
            description: this.description,
            startDate: startDate ? startDate.toDate() : undefined,
            location: this.location,
            image: featuredImage,
            imageCover: coverImage,
        };

        this.wsListener.sendPost('admin.auctions', auctionData);
    }

    convertToBase64(image: any) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = (e: any) => {
                if (!e.target) {
                    reject(new Error('No target'));
                    return;
                }

                resolve(e.target.result);
            };

            reader.onerror = error => {
                reject(error);
            };

            reader.readAsDataURL(image);
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/auctions/add/index.ts